<script setup lang="ts">
import ScenarioChatNewPageInner from './ScenarioChatNewPageInner.vue'
import { useScenarioChatNewPageQuery } from './ScenarioChatNewPage.generated'

const pageQuery = useScenarioChatNewPageQuery()
</script>

<template>
  <ScenarioChatNewPageInner
    v-if="pageQuery.result.value"
    :query="pageQuery.result.value"
  />
</template>
